const NUMBER_WORDS = {
  one: 1,
  two: 2,
  three: 3,
  four: 4,
  five: 5,
  six: 6,
  seven: 7,
  eight: 8,
  nine: 9,
  ten: 10,
};

class MadeToOrderPersonalisation extends HTMLElement {
  connectedCallback() {
    this.input = this.querySelector("[data-letter-input]");
    this.error = this.querySelector("[data-letter-error]");
    this.form = this.input?.form;
    this.productForm = this.closest("product-form-component");
    this.section = this.closest(".shopify-section");
    this.variantInput = this.form?.querySelector('input[name="id"]');
    this.variants = JSON.parse(
      this.querySelector("[data-letter-variants]")?.textContent || "[]",
    );

    if (!this.input || !this.form || !this.variantInput) return;

    this.input.addEventListener("input", this.handleInput);
    this.input.addEventListener("blur", this.handleBlur);
    this.form.addEventListener("submit", this.handleSubmit, true);
    this.productForm?.addEventListener("change", this.handleVariantChange);
    this.section?.addEventListener("variant:update", this.handleVariantUpdate);

    this.variantObserver = new MutationObserver(this.handleVariantChange);
    this.variantObserver.observe(this.variantInput, {
      attributes: true,
      attributeFilter: ["value"],
    });

    this.validate(false);
  }

  disconnectedCallback() {
    this.input?.removeEventListener("input", this.handleInput);
    this.input?.removeEventListener("blur", this.handleBlur);
    this.form?.removeEventListener("submit", this.handleSubmit, true);
    this.productForm?.removeEventListener("change", this.handleVariantChange);
    this.section?.removeEventListener("variant:update", this.handleVariantUpdate);
    this.variantObserver?.disconnect();
  }

  handleInput = () => {
    const cleanedValue = this.input.value.toUpperCase().replace(/[^A-Z ,\-]/g, "");
    if (cleanedValue !== this.input.value) this.input.value = cleanedValue;
    this.validate(true);
  };

  handleBlur = () => this.validate(true);

  handleVariantChange = () => queueMicrotask(() => this.validate(this.input.value.length > 0));

  handleVariantUpdate = (event) => {
    const eventProductId = event.detail?.data?.productId;
    if (eventProductId && String(eventProductId) !== this.productForm?.dataset.productId) return;

    this.selectedVariantId = event.detail?.resource?.id;
    this.validate(this.input.value.length > 0);
  };

  handleSubmit = (event) => {
    if (this.validate(true)) return;

    event.preventDefault();
    event.stopImmediatePropagation();
    this.input.reportValidity();
  };

  getExpectedCount() {
    const selectedVariant = this.variants.find(
      (variant) =>
        String(variant.id) === String(this.selectedVariantId || this.variantInput.value),
    );
    const optionValue = String(selectedVariant?.value || "").trim().toLowerCase();
    const numericValue = Number.parseInt(optionValue, 10);

    return Number.isInteger(numericValue) ? numericValue : NUMBER_WORDS[optionValue];
  }

  validate(showError) {
    const expectedCount = this.getExpectedCount();
    const actualCount = (this.input.value.match(/[A-Z]/g) || []).length;
    const valid = Boolean(expectedCount) && actualCount === expectedCount;
    const message = expectedCount
      ? `Please enter exactly ${expectedCount} ${expectedCount === 1 ? "letter" : "letters"} for this selection.`
      : "Please select the number of letters.";

    this.input.setCustomValidity(valid ? "" : message);
    this.error.textContent = valid || !showError ? "" : message;
    this.error.classList.toggle("hidden", valid || !showError);
    this.input.setAttribute("aria-invalid", String(!valid));

    this.productForm
      ?.querySelectorAll('button[name="add"]')
      .forEach((button) => {
        if (!valid && !button.disabled) {
          button.disabled = true;
          button.dataset.personalisationDisabled = "true";
        } else if (valid && button.dataset.personalisationDisabled === "true") {
          button.disabled = false;
          delete button.dataset.personalisationDisabled;
        }
      });

    return valid;
  }
}

if (!customElements.get("made-to-order-personalisation")) {
  customElements.define(
    "made-to-order-personalisation",
    MadeToOrderPersonalisation,
  );
}
